<template>
  <v-app id="app">
    <sidebar
      v-if="!isLoginPage"
      ref="sidbar"
      :drawer="showDrawer"
      :tree-data="treeData"
      :additional-data="sidebarAdditionalData"
      :test-data="sidebarAdditionalDataString"
      @selected="representSelected"
      @filterRepresent="filterRepresent"
    />
    <toolbar
      v-if="!isLoginPage"
      :title="formTitle"
      :drawerx="showDrawer"
      @change_drawer="change_drawer"
    />
    <v-content class="main-content">
      <keep-alive>
        <transition
          name="slide-fade"
          mode="out-in"
        >
          <router-view
            @renameSelectedRepresent="renameSelectedRepresent"
            @rebuildRepresents="rebuildRepresents"
            @representAdded="representAdded"
          />
        </transition>
      </keep-alive>
    </v-content>
  </v-app>
</template>

<script>
import Sidebar from './shared-components/Sidebar'
import Toolbar from './shared-components/Toolbar'
import axios from 'axios'

export default {
  name: 'App',
  components: {
    Sidebar,
    Toolbar
  },
  props: {
    source: String,
    title: String
  },
  data: () => ({
    showDrawer: true,
    treeData: [],
    treeServerData: [],
    selectedRepresentName: null,
    sidebarAdditionalData: {},
    sidebarAdditionalDataString: ''
  }),
  computed: {
    formTitle () {
      return this.$route.name
    },
    isLoginPage () {
      return this.$route.path === '/login'
    },
    isLogged () {
      return this.$store.state.isLogged
    }
  },
  watch: {
    name (newName) {
      localStorage.name = newName
    },
    isLogged () {
      this.getRepresentsApi()
    }
  },
  mounted () {
    this.getRepresentsApi()
    this.checkDocuments()
    setInterval(
      (function (self) {
        return function () {
          self.checkDocuments()
        }
      })(this), 10000)
    // this.checkRepresentsHealth()
    // setInterval(
    //   (function (self) {
    //     return function () {
    //       self.checkRepresentsHealth()
    //     }
    //   })(this), 10000)
  },
  methods: {
    updateRepresentHealthStatus (id, isOn) {
      var el = document.getElementById('tree' + id)
      if (el != null) {
        el.classList.remove('on')
        el.classList.remove('off')
        if (isOn) {
          el.classList.add('on')
        } else {
          el.classList.add('off')
        }
      }
    },
    checkDocuments () {
      axios.get(`/api/document_request/check/`).then((response) => {
        this.sidebarAdditionalData = response.data
      })
        .catch((err) => {
          console.log(err)
        })
    },
    checkRepresentsHealth () {
      var reprUrl = `/api/represent_health_check/`
      axios.get(reprUrl)
        .then((response) => {
          for (var key in response.data) {
            this.updateRepresentHealthStatus(key, response.data[key])
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    change_drawer () {
      this.showDrawer = !this.showDrawer
    },
    getRepresentsApi () {
      if (!this.isLogged) {
        return
      }
      var reprUrl = `/api/represents/?page_size=all`
      axios.get(reprUrl)
        .then((response) => {
          this.treeServerData = response.data.results
          this.filterRepresent('')
        })
        .catch((err) => {
          console.log(err)
        })
    },
    representSelected (node) {
      // eslint-disable-next-line handle-callback-err
      this.$router.push({ path: `/represents/${node.model.represent_id}` }).catch(err => {})
    },
    filterData (data, tm, searchText) {
      let t
      function addIfFound (addTo, element) {
        if (element.search_text.length > 0) {
          if (element.search_text.toUpperCase().indexOf(searchText.toUpperCase()) >= 0) {
            addTo.push(element)
          }
        } else {
          addTo.push(element)
        }
      }
      for (var d in data) {
        const dd = Object.assign({}, data[d])
        if (dd.children.length > 0) {
          t = Object.assign({}, dd)
          t.children = []
          this.filterData(dd.children, t.children, searchText)
          if (t.children.length > 0) {
            tm.push(t)
          }
        } else {
          addIfFound(tm, dd)
        }
      }
    },
    filterRepresent (val) {
      this.treeData = []
      this.filterData(this.treeServerData, this.treeData, val)
    },
    renameSelectedRepresent (name) {
      this.$refs.sidbar.renameSelectedRepresent(name)
    },
    rebuildRepresents () {
      this.getRepresentsApi()
    },
    representAdded () {
      this.getRepresentsApi()
    }
  }
}
</script>

<style lang="scss">
    @import './assets/css/main.css';
    @import './assets/css/custom.scss';
</style>
<style lang="scss" scoped>
  .main-content {
    padding-top: 40px !important;
  }
  .content-background {
    position: absolute;
    background-image: url('./assets/img/background.png');
    background-repeat: no-repeat;
    background-position: top center;
    opacity: 0.5;
    background-size: 40%;
    top: 15%;
    width: 100%;
    height: 80%;
  }
  .versions {
    font-size: 10px;
    color: #989292;
    position: absolute;
    // right: 16px;
    left: 0;
    bottom: 0;
  }
  .v-application {
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue